import React, { useState, useEffect } from "react";
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Drawer,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import Inventory2Icon from "@mui/icons-material/Inventory2"; // BEST choice

import {
    Home as HomeIcon,
    Business as BusinessIcon,
    MenuBook as MenuBookIcon,
    AccountCircle as AccountCircleIcon,
    Work as WorkIcon,
    CalendarToday as CalendarTodayIcon,
    Payments as PaymentsIcon,
    ConfirmationNumber as ConfirmationNumberIcon,
    Dashboard as DashboardIcon,
    Email as EmailIcon,
    FileCopy as FileCopyIcon,
    People as PeopleIcon,
    Assessment as AssessmentIcon,
    Security as SecurityIcon,
    Help as HelpIcon,
} from "@mui/icons-material";

// 🔹 Menu Items Array
const menuItems = [
    { text: "Overview", icon: <HomeIcon />, route: "/Fmdashbord" }, // Home dashboard
    { text: "ATTENDANCE", icon: <PeopleIcon />, route: "/FmAttendanceTable" }, // Subscription / Users
    { text: "SALARY-STRUCTURE", icon: <MenuBookIcon />, route: "/Adminhrm" }, // HRM / Directory
    { text: "PAY-OUT", icon: <AccountCircleIcon />, route: "" }, // FM / Profile
    { text: "SETTINGS", icon: <ConfirmationNumberIcon />, route: "/Managerprofesanl" }, // Ticketing
];


// 🔹 Bottom Menu Items
const bottomMenuItems = [
    { text: "Logout", icon: <LogoutIcon />, route: "/logout" },
    { text: "nepalweb.com", icon: <HomeIcon />, route: "https://nepalweb.com", external: true },
    { text: "Settings", icon: <SettingsIcon />, route: "/settings" },
];

const Mainsidebar = () => {
    const [open, setOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    


    useEffect(() => {
        setIsDesktop(!isMobile);
        // Desktop पर sidebar हमेशा open रहेगी
        if (!isMobile) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [isMobile]);

    const handleNavigation = (item) => {
        if (item.external) {
            window.open(item.route, '_blank');
        } else {
            navigate(item.route);
        }
        if (isMobile) {
            setOpen(false);
        }
    };

    return (
        <>
            {/* 🟢 Mobile Hamburger Menu Button */}
            {isMobile && (
  <Box
    sx={{
      position: "fixed",
      top: 65,
      left: 8,
      zIndex: 1500,
    }}
  >
    <IconButton
      onClick={() => setOpen(!open)}
      sx={{
        color: "#7564e6",
        width: 38,              // size kam
        height: 38,
        transition: "all 0.3s ease", // smooth effect
        transform: open ? "rotate(90deg)" : "rotate(0deg)",
        "& svg": {
          fontSize: "22px",     // icon size control
          transition: "all 0.3s ease",
        },
      }}
    >
      {open ? <CloseIcon /> : <MenuIcon />}
    </IconButton>
  </Box>
)}


            {/* 🟣 Desktop Sidebar (Fixed) */}
            {isDesktop && (
                <Box
                    sx={{
                        position: "fixed",
                        left: 0,
                        top: 75,
                        width: 240,
                        height: "calc(100vh - 80px)",
                        backgroundColor: "#f8fafc",
                        borderRight: "1px solid #e2e8f0",
                        boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* Logo Section */}
                    <Box
                        sx={{
                            padding: "24px 16px",
                            borderBottom: "1px solid #e2e8f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <h2 style={{ 
                            margin: 0, 
                            color: "#7564e6",
                            fontSize: "24px",
                            fontWeight: "bold" 
                        }}>
                            Envision
                        </h2>
                    </Box>

                    {/* Main Menu */}
                    <List sx={{ 
                        flexGrow: 1, 
                        padding: "16px 8px",
                        overflowY: "auto",
                        '&::-webkit-scrollbar': {
                            width: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#cbd5e1',
                            borderRadius: '2px',
                        }
                    }}>
                        {menuItems.map((item, index) => (
                            <ListItem key={index} disablePadding sx={{ marginBottom: "4px" }}>
                                <ListItemButton
                                    sx={{
                                        borderRadius: "8px",
                                        backgroundColor: location.pathname === item.route ? "#7564e6" : "transparent",
                                        color: location.pathname === item.route ? "#fff" : "#475569",
                                        '&:hover': { 
                                            backgroundColor: location.pathname === item.route ? "#7564e6" : "#f1f5f9" 
                                        },
                                        padding: "10px 16px",
                                    }}
                                    onClick={() => handleNavigation(item)}
                                >
                                    <ListItemIcon sx={{ 
                                        color: location.pathname === item.route ? "#fff" : "#64748b",
                                        minWidth: "36px" 
                                    }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{
                                            style: { 
                                                fontSize: "14px", 
                                                fontWeight: location.pathname === item.route ? "600" : "500",
                                            },
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>

                    {/* Bottom Menu */}
                    {/* <List sx={{ 
                        padding: "16px 8px",
                        borderTop: "1px solid #e2e8f0",
                        backgroundColor: "#f1f5f9",
                    }}>
                        {bottomMenuItems.map((item, index) => (
                            <ListItem key={`bottom-${index}`} disablePadding sx={{ marginBottom: "4px" }}>
                                <ListItemButton
                                    sx={{
                                        borderRadius: "8px",
                                        color: "#475569",
                                        '&:hover': { 
                                            backgroundColor: "#e2e8f0" 
                                        },
                                        padding: "10px 16px",
                                    }}
                                    onClick={() => handleNavigation(item)}
                                >
                                    <ListItemIcon sx={{ 
                                        color: "#64748b",
                                        minWidth: "36px" 
                                    }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{
                                            style: { 
                                                fontSize: "14px", 
                                                fontWeight: "500",
                                            },
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List> */}
                </Box>
            )}

            {/* 🟡 Mobile Drawer */}
            <Drawer
                anchor="left"
                open={open && isMobile}
                onClose={() => setOpen(false)}
                ModalProps={{
                    keepMounted: true,
                }}
                PaperProps={{
                    sx: {
                        width: 280,
                        backgroundColor: "#f8fafc",
                        boxShadow: "2px 0 20px rgba(0,0,0,0.1)",
                    },
                }}
            >
                {/* Mobile Header */}
                <Box
                    sx={{
                        padding: "24px 20px",
                        backgroundColor: "#7564e6",
                        color: "#fff",
                        borderBottom: "1px solid #334155",
                    }}
                >
                    <h2 style={{ 
                        margin: 0, 
                        fontSize: "22px",
                        fontWeight: "bold" 
                    }}>
                        Envision
                    </h2>
                    
                </Box>

                {/* Mobile Menu */}
                <List sx={{ 
                    padding: "16px 12px",
                    flexGrow: 1,
                }}>
                    {menuItems.map((item, index) => (
                        <ListItem key={index} disablePadding sx={{ marginBottom: "8px" }}>
                            <ListItemButton
                                sx={{
                                    borderRadius: "8px",
                                    backgroundColor: location.pathname === item.route ? "#7564e6" : "transparent",
                                    color: location.pathname === item.route ? "#fff" : "#475569",
                                    '&:hover': { 
                                        backgroundColor: location.pathname === item.route ? "#7564e6" : "#f1f5f9" 
                                    },
                                    padding: "12px 16px",
                                }}
                                onClick={() => handleNavigation(item)}
                            >
                                <ListItemIcon sx={{ 
                                    color: location.pathname === item.route ? "#fff" : "#64748b",
                                    minWidth: "36px" 
                                }}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.text}
                                    primaryTypographyProps={{
                                        style: { 
                                            fontSize: "15px", 
                                            fontWeight: location.pathname === item.route ? "600" : "500",
                                        },
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>

                {/* Mobile Bottom Menu */}
                <Box sx={{ 
                    padding: "16px 12px",
                    borderTop: "1px solid #e2e8f0",
                    backgroundColor: "#f1f5f9",
                }}>
                    <List sx={{ padding: 0 }}>
                        {bottomMenuItems.map((item, index) => (
                            <ListItem key={`mobile-bottom-${index}`} disablePadding sx={{ marginBottom: "8px" }}>
                                <ListItemButton
                                    sx={{
                                        borderRadius: "8px",
                                        color: "#475569",
                                        '&:hover': { 
                                            backgroundColor: "#e2e8f0" 
                                        },
                                        padding: "12px 16px",
                                    }}
                                    onClick={() => handleNavigation(item)}
                                >
                                    <ListItemIcon sx={{ 
                                        color: "#64748b",
                                        minWidth: "36px" 
                                    }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{
                                            style: { 
                                                fontSize: "15px", 
                                                fontWeight: "500",
                                            },
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>

            {/* Content Spacer for Desktop */}
            {isDesktop && (
                <Box sx={{ width: 240, flexShrink: 0 }} />
            )}
        </>
    );
};

export default Mainsidebar;

